<!-- Breadcrumb -->
<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
    <h5 class="mb-0">
        {{ mode === 'add' ? ('Add Plant' | translate ) : ('Update Plant' | translate) }}
    </h5>
    <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
        <li class="breadcrumb-item position-relative">
            <a routerLink="/users">
                {{'Users_List' | translate}}
            </a>
        </li>
        <li class="breadcrumb-item position-relative">
            {{'Plants' | translate}}
        </li>
        <li class="breadcrumb-item position-relative">
            {{'Add Plant' | translate}}
        </li>
    </ol>
</div>
<mat-card class="daxa-card users-card mb-25 border-radius bg-white border-none d-block">
    <mat-stepper #stepper orientation="vertical" [linear]="true" (selectionChange)="onStepChange($event)">
        <!-- Personal Information step -->
        <mat-step [stepControl]="personalForm" [completed]="isLocked">
            <ng-template matStepLabel>
                {{'Personal information' | translate}}
            </ng-template>
            <form [formGroup]="personalForm">
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                        <div class="mb-20">
                            <label class="main-label d-block lh-1 text-black">
                                {{ 'Installation_date' | translate }}
                            </label>

                            <mat-form-field class="w-100 installation-date-field">

                                <mat-label>
                                    {{ 'Select_installation_date' | translate }}
                                </mat-label>

                                <input matInput formControlName="installationDate"
                                    [matDatepicker]="installationDatePicker" [max]="today" readonly
                                    placeholder="DD/MM/YYYY" (click)="!isLocked && installationDatePicker.open()" />

                                <!-- Clear selected date -->
                                <button *ngIf="
                    personalForm.get('installationDate')?.value &&
                    !isLocked
                " mat-icon-button matSuffix type="button" class="clear-date-button"
                                    [attr.aria-label]="'Clear installation date'"
                                    (click)="clearInstallationDate($event)">
                                    <mat-icon>close</mat-icon>
                                </button>

                                <!-- Calendar button -->
                                <mat-datepicker-toggle matIconSuffix [for]="installationDatePicker"
                                    [disabled]="isLocked">
                                </mat-datepicker-toggle>

                                <mat-datepicker #installationDatePicker startView="multi-year">
                                </mat-datepicker>

                                <mat-hint>
                                    {{ 'Installation_date_optional' | translate }}
                                </mat-hint>

                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="mb-20">
                            <label class="main-label d-block lh-1 text-black">
                                {{'Name' | translate}}
                            </label>
                            <mat-form-field>
                                <input readonly formControlName="plantOwner" matInput>
                            </mat-form-field>
                        </div>
                    </div>
                    <div hidden class="col-lg-6 col-md-6 col-sm-6">
                        <div class="mb-20">
                            <label class="main-label d-block lh-1 text-black">
                                UserId
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    Enter UserId
                                </mat-label>
                                <input formControlName="userId" matInput type="text" readonly>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="mb-20">
                            <label class="main-label d-block lh-1 text-black">
                                {{'Email' | translate}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{'Enter email' | translate}}
                                </mat-label>
                                <input formControlName="email" matInput readonly>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="mb-20">
                            <label class="main-label d-block lh-1 text-black">
                                {{'Phone_number' | translate}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{'Enter phone number' | translate}}
                                </mat-label>
                                <input [readonly]="isLocked" matInput placeholder="E.g. +123 452183"
                                    formControlName="phone" type="tel">
                                <mat-error
                                    *ngIf="personalForm.get('phone')?.hasError('required') && (personalForm.get('phone')?.touched || personalForm.get('phone')?.dirty)">
                                    {{'Phone number is required' | translate}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="mb-20">
                            <label class="main-label d-block lh-1 text-black">
                                {{'Address' | translate}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{'Enter address' | translate}}
                                </mat-label>
                                <input [readonly]="isLocked" formControlName="address" matInput
                                    placeholder="E.g. Copenhagen">
                                <mat-error
                                    *ngIf="personalForm.get('address')?.hasError('required') && (personalForm.get('address')?.touched || personalForm.get('address')?.dirty)">
                                    {{'Address is required' | translate }}
                                </mat-error>
                            </mat-form-field>
                            <mat-error
                                *ngIf="personalForm.get('address')?.hasError('address') && (personalForm.get('address')?.touched || personalForm.get('address')?.dirty)">
                                {{'Address is required' | translate}}
                            </mat-error>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="mb-20">
                            <label class="main-label d-block lh-1 text-black">
                                {{'City' | translate}}
                            </label>
                            <mat-form-field class="w-full city-field">
                                <mat-label>{{'City' | translate}}</mat-label>
                                <input #cityInput [readonly]="isLocked" type="text" matInput required
                                    [formControl]="citySearchCtrl" [matAutocomplete]="cityAuto"
                                    placeholder="Type to search city" />
                                <button [disabled]="isLocked" type="button" matSuffix class="add-city-btn"
                                    (click)="openAddCity($event)">
                                    + {{"Add new city" | translate}}
                                </button>
                                <mat-autocomplete #cityAuto="matAutocomplete"
                                    (optionSelected)="onCityOptionSelected($event)">
                                    <mat-option *ngFor="let c of filteredCities$ | async" [value]="c">
                                        <div class="flex items-center justify-between w-full">
                                            <span>{{ c.title }}</span>
                                        </div>
                                    </mat-option>
                                    <mat-option disabled *ngIf="(filteredCities$ | async)?.length === 0">No
                                        results
                                    </mat-option>
                                </mat-autocomplete>
                                <mat-hint *ngIf="selectedCity">Time Zone: {{ selectedCity.timeZoneId }}</mat-hint>
                                <mat-error *ngIf="personalForm.get('cityId')?.hasError('required')">{{'City is required'
                                    | translate }}</mat-error>
                                <mat-error *ngIf="personalForm.get('cityId')?.hasError('cityMismatch')">{{'Please pick a
                                    city from the list' | translate}}</mat-error>
                                <mat-error *ngIf="personalForm.get('cityId')?.hasError('timezoneMissing')">{{'Selected
                                    city has no time zone' | translate}}</mat-error>
                            </mat-form-field>
                            <input [readonly]="isLocked" required type="hidden" formControlName="cityId">
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="mb-20">
                            <label class="main-label d-block lh-1 text-black">
                                {{'Username' | translate}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{'Enter username' | translate}}
                                </mat-label>
                                <input formControlName="username" matInput readonly>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="mb-20">
                            <label class="main-label d-block lh-1 text-black">
                                {{'Low_price_threshold' | translate}}

                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{'Enter low price threshold' | translate}}

                                </mat-label>
                                <input [readonly]="isLocked" step="0.01" type="number"
                                    formControlName="lowPriceThreshold" matInput>
                                <mat-error *ngIf="personalForm.get('lowPriceThreshold')?.hasError('required')">
                                    Low price threshold is required
                                </mat-error>
                                <span class="DDKspan" matSuffix>DKK</span>
                                <mat-hint>
                                    {{'The affordability threshold for each customer,Prices below this threshold are
                                    considered cheap.' | translate}}
                                </mat-hint>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="mb-20">
                            <label class="main-label d-block lh-1 text-black">
                                {{'Customer_type' | translate}}
                            </label>

                            <mat-form-field class="w-full">
                                <mat-label>{{'Customer_type' | translate}}</mat-label>
                                <!-- Combo box without search -->
                                <mat-select formControlName="customerType" [disabled]="isLocked"
                                    placeholder="Select customer type" required>
                                    <mat-option *ngFor="let c of customerTypeOptions" [value]="c">
                                        {{ c }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-error
                                *ngIf="personalForm.get('customerType')?.hasError('required')
                                            && (personalForm.get('customerType')?.touched || personalForm.get('customerType')?.dirty)">
                                customerType is required.
                            </mat-error>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="mb-20">
                            <label class="main-label d-block lh-1 text-black">
                                {{'Price_class' | translate}}
                            </label>
                            <mat-form-field class="w-full">
                                <mat-label>{{'Price_class' | translate}}</mat-label>
                                <mat-select [disabled]="isLocked" formControlName="priceClass"
                                    placeholder="Select price class">
                                    <mat-option [disabled]="isLocked" *ngFor="let pc of priceClass"
                                        [value]="pc.priceClass">
                                        {{ pc.priceClass }}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="personalForm.get('priceClass')?.hasError('required') && (personalForm.get('priceClass')?.touched || personalForm.get('priceClass')?.dirty)">
                                    {{'Price class is required' | translate}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <app-plant-location-component formControlName="location"
                            [editable]="mode === 'update' || !isLocked">
                        </app-plant-location-component>
                    </div>
                    <div class="col-lg-12 col-md-6 col-sm-6">
                        <label class="field-label">{{'Plant image' | translate}}</label>
                        <app-upload-plant-image (fileHandleReady)="onFileHandleReady($event)"
                            (imageUploaded)="onImageUploaded($event)">
                        </app-upload-plant-image>
                    </div>
                </div>
                <div>
                    <button mat-flat-button class="daxa"
                        [disabled]="(isSubmitting || personalForm.invalid) || (isLocked)" (click)="onClickFirstStep()">
                        {{ isSubmitting ? ' (' + ('Waiting ...' | translate) + ') ' : mode === 'add' ? ('Add Plant' |
                        translate) : ('Update Plant' | translate) }}
                    </button>
                </div>
            </form>
        </mat-step>
        <!-- Inverters information step -->
        <mat-step [stepControl]="invertersForm" *ngIf="mode !== 'update'" [editable]="!!currentPlantId">
            <ng-template matStepLabel>{{'Inverters information' | translate}}</ng-template>
            <form [formGroup]="invertersForm">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="mb-20">
                            <label class="main-label d-block lh-1 text-black">{{'Brand' | translate}}</label>
                            <mat-form-field class="w-full">
                                <mat-label>{{'Brand' | translate}}</mat-label>
                                <input type="text" matInput formControlName="brand" [matAutocomplete]="brandAuto"
                                    placeholder="Type to search brand" />
                                <mat-autocomplete #brandAuto="matAutocomplete"
                                    (optionSelected)="onBrandSelected($event)">
                                    <mat-option *ngFor="let b of filteredBrands$ | async" [value]="b">{{ b
                                        }}</mat-option>
                                </mat-autocomplete>
                                <mat-error *ngIf="invertersForm.get('brand')?.hasError('required')">{{'Brand is
                                    required' | translate}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="mb-20">
                            <label class="main-label d-block lh-1 text-black">{{'Model' | translate}}</label>
                            <mat-form-field class="w-full">
                                <mat-label>{{'Model' | translate}}</mat-label>
                                <input type="text" matInput formControlName="model" [matAutocomplete]="modelAuto"
                                    placeholder="Type to search model" />
                                <mat-autocomplete #modelAuto="matAutocomplete">
                                    <mat-option *ngFor="let m of filteredModels$ | async" [value]="m">{{ m
                                        }}</mat-option>
                                </mat-autocomplete>
                                <mat-error *ngIf="invertersForm.get('model')?.hasError('required')">{{'Model is
                                    required' | translate}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="mb-20">
                            <label class="main-label d-block lh-1 text-black">{{'Serial number' | translate}}</label>
                            <mat-form-field>
                                <mat-label>{{'Serial number' | translate}}</mat-label>
                                <input matInput formControlName="serialNumber" placeholder="e.g. ABC-123">
                                <mat-error *ngIf="invertersForm.get('serialNumber')?.hasError('required')">{{'Serial
                                    number is required' | translate}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="mb-20">
                            <label class="main-label d-block lh-1 text-black">{{'Max production capacity (kWh)' |
                                translate}}</label>
                            <mat-form-field>
                                <mat-label>{{'Max production capacity (kWh)' | translate}}</mat-label>
                                <input type="number" matInput formControlName="maxProductionCapacity"
                                    placeholder="e.g. 5">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="mb-20">
                            <label class="main-label d-block lh-1 text-black">{{'Total battery capacity (kWh)' |
                                translate}}</label>
                            <mat-form-field>
                                <mat-label>{{'Total battery capacity (kWh)' | translate}}</mat-label>
                                <input type="number" matInput formControlName="totalBatteryCapacityKwhsolarPanels"
                                    placeholder="e.g. 10">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="mb-20">
                            <label class="main-label d-block lh-1 text-black">{{'Battery charge power rate (kW)' |
                                translate}}</label>
                            <mat-form-field>
                                <mat-label>{{'Battery charge power rate (kW)' | translate}}</mat-label>
                                <input type="number" matInput formControlName="batteryChargePowerRateKw"
                                    placeholder="e.g. 3">
                            </mat-form-field>
                        </div>
                    </div>
                    <!-- Solar Threshold -->
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <div class="mb-20">
                            <label class="main-label d-block lh-1 text-black">
                                {{ 'solar threshold' | translate }}
                            </label>

                            <mat-form-field class="w-full">
                                <mat-label>{{ 'solar threshold' | translate }}</mat-label>

                                <input matInput formControlName="solarFactorThreshold" placeholder="e.g. 0.2"
                                    autocomplete="off" />

                                <mat-error *ngIf="invertersForm.controls.solarFactorThreshold.hasError('required')">
                                    {{ 'solar_threshold_required' | translate }}
                                </mat-error>

                                <mat-error
                                    *ngIf="invertersForm.controls.solarFactorThreshold.hasError('solarThresholdInvalid')">
                                    {{ 'solar_threshold_invalid' | translate }}
                                </mat-error>

                                <mat-error
                                    *ngIf="invertersForm.controls.solarFactorThreshold.hasError('solarThresholdOutOfRange')">
                                    {{ 'solar_threshold_out_of_range' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="mb-20 solar-panel-input">
                            <label class="main-label d-block lh-1 text-black">{{'Total panel power (kWh)' |
                                translate}}</label>
                            <mat-form-field>
                                <mat-label>{{'Total panel power (kWh)' | translate}}</mat-label>
                                <input type="number" matInput formControlName="totalPanelPowerKwh" placeholder="e.g. 3">
                            </mat-form-field>
                        </div>
                    </div>
                    <!-- meterinpoint -->
                    <div formArrayName="meteringPoints" class="w-full">
                        <div class="flex items-center justify-between mb-10">
                            <button mat-stroked-button color='primary' type="button" (click)="addMeteringPoint()">
                                {{'Add metering point' | translate}}
                            </button>
                        </div>
                        <div class="grid gap-4" *ngFor="let row of meteringPointsFA.controls; let i = index"
                            [formGroupName]="i">
                            <div class="grid grid-cols-12 gap-3 items-center">
                                <!-- meteringPointId -->
                                <mat-form-field class="col-span-5">
                                    <mat-label>{{'Metering Point ID' | translate}}</mat-label>
                                    <input matInput formControlName="meteringPointId" placeholder="e.g. 579" />
                                </mat-form-field>
                                <mat-form-field class="col-span-5">
                                    <mat-label>{{'Meter Type' | translate}}</mat-label>
                                    <input type="text" matInput formControlName="meterType" [matAutocomplete]="mtAuto"
                                        placeholder="Search meter type" />
                                    <mat-autocomplete #mtAuto="matAutocomplete">
                                        <mat-option *ngFor="let mt of getMeterTypeFiltered(i) | async"
                                            [value]="mt.title">
                                            <div class="flex items-center justify-between w-full">
                                                <span>{{ mt.title}} </span>
                                                <span class="gap">,</span>
                                                <span class="opacity-70 text-xs">{{ mt.description }}</span>
                                            </div>
                                        </mat-option>
                                    </mat-autocomplete>
                                    <mat-error *ngIf="row.get('meterType')?.hasError('required')">{{'Required' |
                                        translate}}</mat-error>
                                </mat-form-field>
                                <!-- isMain -->
                                <div class="col-span-1 flex items-center">
                                    <mat-checkbox formControlName="isMain" (change)="setAsMain(i)">{{'Main' |
                                        translate}}</mat-checkbox>
                                </div>

                                <!-- remove -->
                                <div class="col-span-1 flex items-center justify-end">
                                    <button mat-icon-button color="warn" type="button" (click)="removeMeteringPoint(i)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <button mat-flat-button matStepperPrevious class="mr-15">{{'Review' | translate}}</button>
                    <button mat-flat-button color="primary" class="daxa"
                        [disabled]="isSubmittingInverter || invertersForm.invalid " (click)="submitInverterStep()">
                        {{ isSubmittingInverter ? '(' + ('Saving…' | translate) + ')' : '(' + ('Save Inverter' |
                        translate) + ')' }}
                    </button>
                </div>
            </form>
        </mat-step>
    </mat-stepper>
</mat-card>